<template>
  <div class="   absolute top-[25px] right-[32px] min-w-[25px] min-h-[25px]  flex flex-col z-10">
    <div class=" flex flex-row">
      <div class="containerSearch" v-if="displayFormSearch">
        <div class="flex flex-row containerTxtSearch">
          <input
            type="text" id="searchTxt"
            class="text-xs"
            :placeholder="$e('Veuillez entrer une adresse') + ' ' + (scopeSearch === 'fr' ? $e('ou pos. GPS (48.8574 2.352)') : '')"
            autocomplete="off"
            v-model="addressValue"
            @keyup="setSearch()"
          />
          <div id="containerIconClearAddressSearch" class="flex map_option" v-if="searchTxt !== ''"
            @click="clearAddrSearch">
            <div id="iconClearAddressSearch" class="iconsAddressSearch">
              <svg class="fill-current w-full rotate-45" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75">
                <rect width="75" height="15" transform="translate(0 30)"></rect>
                <rect width="75" height="15" transform="translate(44.5) rotate(90)"></rect>
              </svg>
            </div>
          </div>
        </div>

        <div id="containerResultSearch" class="containerLstResultSearch"
          v-if="lstResultSearch.length > 0 && searchTxt !== ''">
          <div v-for="item in lstResultSearch" :key="'itmResultSearchAddr_' + item.key">
            <div class="cursor-pointer itemResultSearch" @click="selectResult(item)">
              <span class="itemResultSearchPrimary">{{ item.properties.label }}</span>
              <span class="itemResultSearchSecondary">{{ item.properties.context }}</span>
            </div>
          </div>
        </div>
      </div>

      <div id="choiceScopeSearch">
        <div class="map_option" v-if="displayFormSearch">
          <input type="checkbox" id="iconScopeSelected" class="hidden" v-model="displayChoiceScope" />
          <label class="iconsAddressSearch" for="iconScopeSelected" v-html="currentScopeIcon"
            :title="currentScopeTooltip"> </label>
        </div>
        <div class=" flex flex-col z-10" v-if="displayChoiceScope && displayFormSearch">
          <div class="map_option " v-for="item in lstScopes" :key="'scopeSearch_' + item.key"
            @click.stop.prevent="changeScopeSearch(item.key)">
            <input type="radio" name="scopeSearchAddress_choice" class="hidden" :id="'itemScopeSearch_' + item.key"
              :checked="scopeSearch === item.key" />
            <label class="iconsAddressSearch" :for="'itemScopeSearch_' + item.key" v-html="item.htmlIcon"
              :title="item.tooltip"></label>
          </div>
        </div>
      </div>

      <div class="map_option ">
        <input type="checkbox" id="formSearchAddress" class="hidden" v-model="displayFormSearch"
          :disabled="lstResultSearch.length > 0 || searchTxt !== '' ? true : false">
        <label class=" iconsAddressSearch " for="formSearchAddress" :title="$e('Recherche d\'adresse')">
          <svg viewBox="0 0 100 100" fill="red" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                d="m47.398 78.398c-8.3008 0-16.102-3.1992-21.898-9.1016-5.8984-5.8008-9.1016-13.602-9.1016-21.898 0-8.3008 3.1992-16.102 9.1016-21.898 5.8984-5.8008 13.602-9.1016 21.898-9.1016 8.3008 0 16.102 3.1992 21.898 9.1016 5.8984 5.8984 9.1016 13.602 9.1016 21.898 0 8.3008-3.1992 16.102-9.1016 21.898-5.7969 5.9023-13.598 9.1016-21.898 9.1016zm0-56.797c-6.8984 0-13.398 2.6992-18.301 7.6016-4.8984 4.8984-7.6016 11.398-7.6016 18.301 0 6.8984 2.6992 13.398 7.6016 18.301 4.8984 4.8984 11.398 7.6016 18.301 7.6016 6.8984 0 13.398-2.6992 18.301-7.6016 4.8984-4.8984 7.6016-11.398 7.6016-18.301s-2.6992-13.504-7.5-18.402c-4.9023-4.8008-11.402-7.5-18.402-7.5z" />
              <path d="m65.746 69.336 3.6055-3.6055 14.141 14.141-3.6055 3.6055z" />
            </g>
          </svg>
        </label>
      </div>


    </div>

  </div>
</template>

<script>
import { ref } from "vue";
import Map from "@/utils/Map";
import AddressSearch from "@/utils/AddressSearch";
import { urlSearchAddress } from '@/utils/constant/settings_constantes';

export default {
  name: "Map_Recherche",
  setup() {
    return {
      addressValue: ref(''),
      searchTxt: ref(''),
      lstResultSearch: ref([]),
      displayFormSearch: ref(false),
      scopeSearch: ref('fr'),
      lstScopes: urlSearchAddress,
      displayChoiceScope: ref(false),

      hasIcon: false,
    };
  },

  mounted() {
  },

  computed: {
    currentScopeIcon() {
      return this.lstScopes[this.scopeSearch].htmlIcon;
    },
    currentScopeTooltip() {
      return this.lstScopes[this.scopeSearch].tooltip;
    },

  },

  methods: {
    async setSearch() {
      if (this.addressValue.length > 3) {

        const infosSearch = {
          url: this.lstScopes[this.scopeSearch].url,
          urlReverse: this.lstScopes[this.scopeSearch].urlReverse,
          txtsearch: this.addressValue,
          complurl: (this.lstScopes[this.scopeSearch].needToken !== undefined && this.lstScopes[this.scopeSearch].needToken != null && this.lstScopes[this.scopeSearch].needToken ? this.lstScopes[this.scopeSearch].keyToken : ""),
          scopeSearch: this.scopeSearch
        };


        let response = await AddressSearch.get(infosSearch);
        if (response.query === this.addressValue) {
          this.lstResultSearch = response.features;


          this.clearIconSearch();
        }
      }
      this.searchTxt = this.addressValue;
    },

    selectResult(result) {
      this.addressValue = result.properties.label;
      this.lstResultSearch.splice(0);


      if (result.bbox !== null && result.bbox !== undefined) {
        Map.flyToBbox({
          xmin: result.bbox[0],
          xmax: result.bbox[2],
          ymin: result.bbox[1],
          ymax: result.bbox[3],
        });

        const center = Map.getCenterRectangle({
          xmin: result.bbox[0],
          xmax: result.bbox[2],
          ymin: result.bbox[1],
          ymax: result.bbox[3],
        });

        // créer un picto
        Map.element.staticmapelements.addIcon('pictoAddressSearch', 'map_marker', center[0], center[1]);
        this.hasIcon = true;

      }
      else {
        // flyTo point
        Map.focus({
          lng: result.geometry.coordinates[0],
          lat: result.geometry.coordinates[1],
          hgt: 500
        });

        // créer un picto
        Map.element.staticmapelements.addIcon('pictoAddressSearch', 'map_marker', result.geometry.coordinates[0], result.geometry.coordinates[1]);
        this.hasIcon = true;
      }

    },

    clearAddrSearch() {
      this.addressValue = '';
      this.searchTxt = '';
      this.lstResultSearch = [];

      this.clearIconSearch();
    },


    clearIconSearch() {
      Map.element.staticmapelements.removeByName('pictoAddressSearch');
      this.hasIcon = false;
    },

    changeScopeSearch(key) {
      if (this.scopeSearch !== key) {
        // modifie l'item sélectionné
        this.scopeSearch = key;
        // on reset la recherche actuelle
        this.clearAddrSearch();
      }

      // masquer liste déroulante
      this.displayChoiceScope = false;

    }

  }
};
</script>
